function initCartUpsell() {

document.querySelectorAll(".m-cart-new-upsell").forEach(function (section) {

if (section.dataset.initialized) return;
section.dataset.initialized = "true";

const wrapper = section.querySelector(".m-cart-nu-wrapper");
const prevBtn = section.querySelector(".m-cart-nu-prev");
const nextBtn = section.querySelector(".m-cart-nu-next");
const container = section.querySelector(".m-cart-nu-container");

if (!wrapper || !prevBtn || !nextBtn || !container) return;

function getScrollAmount() {
  const item = container.querySelector(".m-cart-nu-prod");
  return item ? item.getBoundingClientRect().width : 300;
}

prevBtn.addEventListener("click", function () {
  wrapper.scrollBy({
    left: -getScrollAmount(),
    behavior: "smooth"
  });
});

nextBtn.addEventListener("click", function () {
  wrapper.scrollBy({
    left: getScrollAmount(),
    behavior: "smooth"
  });
});

});
}

function initUpsellPopups() {

document.querySelectorAll('.m-upsell-popup').forEach(function (popup) {

if (popup.dataset.variantInit) return;
popup.dataset.variantInit = "true";

const variantsEl = popup.querySelector('.m-product-variants-json');

if (!variantsEl) return;

const variants = JSON.parse(variantsEl.textContent);
const atcBtn = popup.querySelector('.m-popup-atc');

function updateVariant() {

  const selectedOptions = [];

  popup.querySelectorAll('.m-popup-option').forEach(function (fieldset) {
    const checked = fieldset.querySelector('input[type="radio"]:checked');

    if (checked) {
      selectedOptions.push(checked.value);
    }
  });

  const matchedVariant = variants.find(function (variant) {
    return selectedOptions.every(function (optionValue, index) {
      return variant.options[index] === optionValue;
    });
  });

  if (!matchedVariant) return;

  atcBtn.dataset.variantId = matchedVariant.id;

  const priceEl = popup.querySelector('.m-popup-price');

  if (priceEl) {
    priceEl.innerHTML = matchedVariant.price;
  }

  atcBtn.disabled = !matchedVariant.available;
  atcBtn.textContent = matchedVariant.available
    ? 'Add To Cart'
    : 'Sold Out';
}

popup.addEventListener('change', function (e) {
  if (e.target.matches('.m-popup-option input[type="radio"]')) {
    updateVariant();
  }
});

updateVariant();

});
}

document.addEventListener("DOMContentLoaded", function () {

initCartUpsell();
initUpsellPopups();

/* Open Popup */
document.addEventListener('click', function (e) {

const openBtn = e.target.closest('.m-cart-nu-prod-popup-btn');

if (!openBtn) return;

const popup = document.getElementById(
  `m-upsell-popup-${openBtn.dataset.productId}`
);

if (popup) {
  popup.classList.add('active');
  document.body.classList.add('overflow-hidden');
}

});

/* Close Popup */
document.addEventListener('click', function (e) {

if (
  e.target.classList.contains('m-upsell-popup-overlay') ||
  e.target.classList.contains('m-upsell-close')
) {

  const popup = e.target.closest('.m-upsell-popup');

  if (popup) {
    popup.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
}

});

/* Add To Cart */
document.addEventListener('click', async function (e) {

const btn = e.target.closest('.m-popup-atc');

if (!btn) return;

const variantId = btn.dataset.variantId;

if (!variantId) return;

btn.disabled = true;

const originalText = btn.textContent.trim();
btn.textContent = 'Adding...';

try {

  const addRes = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: 1
    })
  });

  if (!addRes.ok) {
    const err = await addRes.json();
    throw new Error(err.description || 'Failed to add to cart');
  }

  const cart = await fetch('/cart.js').then(r => r.json());

  import('@theme/events').then(({ CartUpdateEvent }) => {
    document.dispatchEvent(
      new CartUpdateEvent(cart, 'manual-trigger', {
        source: 'm-upsell-popup'
      })
    );
  });

  const popup = btn.closest('.m-upsell-popup');

  if (popup) {
    popup.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  document.querySelector('cart-drawer-component')?.open();

  setTimeout(() => {
    initCartUpsell();
    initUpsellPopups();
  }, 300);

} catch (error) {

  console.error('ATC Error:', error);
  btn.textContent = originalText;

} finally {

  btn.disabled = false;

}

});

/* Watch for Cart Drawer Reloads */
const observer = new MutationObserver(() => {
initCartUpsell();
initUpsellPopups();
});

observer.observe(document.body, {
childList: true,
subtree: true
});
});

(function() {
  // Load Swiper CSS
  if (!document.querySelector('#swiper-css')) {
    const link = document.createElement('link');
    link.id = 'swiper-css';
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(link);
  }

  function loadSwiper(callback) {
    if (window.Swiper) return callback();
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = callback;
    document.body.appendChild(script);
  }

  // Update bundle totals based on checked items
  function updateBundleTotals(form) {
    const bundle = form.closest('.m-upsell-bundle');
    if (!bundle) return;

    const bundleItems = form.querySelectorAll('[data-bundle-item]');
    const priceElement = bundle.querySelector('[data-bundle-price-total]');
    const compareElement = bundle.querySelector('[data-bundle-compare-total]');
    const compareWrapper = bundle.querySelector('.m-ub-total-compare-wrapper');

    if (!priceElement) return;

    let totalPrice = 0;
    let totalCompare = 0;
    let currencySymbol = 'Rs.'; // Default fallback

    // Extract currency symbol from the first product price
    const firstProductPrice = form.querySelector('.m-ub-product-price');
    if (firstProductPrice) {
      const priceText = firstProductPrice.textContent.trim();
      // Extract currency symbol (non-numeric characters at the start, including dots)
      const match = priceText.match(/^([^\d\s,]+)/);
      if (match) {
        currencySymbol = match[1];
      }
    }

    bundleItems.forEach(item => {
      const checkbox = item.querySelector('.bundle-checkbox');
      
      if (checkbox && checkbox.checked) {
        const price = parseFloat(item.dataset.price) || 0;
        const comparePrice = parseFloat(item.dataset.comparePrice) || price;
        
        totalPrice += price;
        totalCompare += comparePrice;
      }
    });

    // Format money function
    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      // Remove decimals if .00
      const cleanAmount = amount.replace(/\.00$/, '');
      // Add thousand separators
      const parts = cleanAmount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return currencySymbol + parts.join('.');
    }

    // Update price display
    priceElement.textContent = formatMoney(totalPrice);
    
    if (compareElement) {
      compareElement.textContent = formatMoney(totalCompare);
    }

    // Show/hide compare price wrapper
    if (compareWrapper) {
      if (totalCompare > totalPrice) {
        compareWrapper.style.display = '';
      } else {
        compareWrapper.style.display = 'none';
      }
    }
  }

  // Enable/Disable Add Bundle button
  function updateBundleButton(form) {
    const checkboxes = form.querySelectorAll('.bundle-checkbox');
    const button = form.querySelector('.m-ub-add-bundle-btn');
    if (!button) return;
    button.disabled = !Array.from(checkboxes).some(cb => cb.checked);
  }

  function initBundleForms(scope = document) {
    scope.querySelectorAll('[data-m-bundle-form]').forEach(form => {
      if (form.dataset.init) return;
      form.dataset.init = 'true';

      updateBundleButton(form);
      updateBundleTotals(form); // Initialize totals

      form.querySelectorAll('.bundle-checkbox').forEach(cb => {
        cb.addEventListener('change', () => {
          updateBundleButton(form);
          updateBundleTotals(form); // Update totals on checkbox change
        });
      });

      form.addEventListener('submit', async e => {
        e.preventDefault();
        const button = form.querySelector('[data-u-atc-button]');
        const checkboxes = form.querySelectorAll('.bundle-checkbox:checked');
        if (!checkboxes.length) return;

        button.disabled = true;
        try {
          const items = Array.from(checkboxes).map(cb => ({ id: cb.value, quantity: 1 }));
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });

          const cart = await fetch('/cart.js').then(r => r.json());
          import('@theme/events').then(({ CartUpdateEvent }) => {
            document.dispatchEvent(new CartUpdateEvent(cart, 'manual-trigger', { source: 'm-upsell-bundle' }));
          });

          document.querySelector('cart-drawer-component')?.open();
        } catch (err) {
          console.error(err);
          alert('Error adding bundle');
        } finally {
          button.disabled = false;
        }
      });
    });
  }

  function initBundleImageToggle(scope = document) {
    scope.querySelectorAll('[data-m-bundle-form]').forEach(form => {
      form.querySelectorAll('.bundle-checkbox').forEach(cb => {
        cb.addEventListener('change', function() {
          const img = form.closest('.m-upsell-bundle')?.querySelector(`.m-ub-prod-img-wrapper[data-variant-id="${this.value}"]`);
          if (img) img.classList.toggle('is-disabled', !this.checked);
        });
      });
    });
  }

  let swiperInstance = null;
  function initSwiper() {
    const el = document.querySelector('[data-m-popup-swiper]');
    if (!el || !window.Swiper) return;

    swiperInstance?.destroy(true, true);
    swiperInstance = new Swiper(el, {
      slidesPerView: 1.3,
      spaceBetween: 20,
      navigation: { nextEl: '.m-ub-swiper-button-next', prevEl: '.m-ub-swiper-button-prev' },
      pagination: { el: '.m-ub-swiper-pagination', clickable: true },
      loop: false
    });
  }

  function initPopup() {
    const overlay = document.querySelector('[data-m-popup-overlay]');
    if (!overlay) return;

    const form = overlay.querySelector('[data-m-bundle-form]');
    if (form) {
      updateBundleButton(form);
      updateBundleTotals(form); // Initialize popup totals
    }

    document.querySelectorAll('[data-m-popup-trigger]').forEach(trigger => {
      if (trigger.dataset.init) return;
      trigger.dataset.init = 'true';
      trigger.addEventListener('click', () => {
        loadSwiper(() => {
          overlay.classList.add('is-active');
          document.body.style.overflow = 'hidden';
          initSwiper();
        });
      });
    });

    overlay.querySelector('[data-m-popup-close]')?.addEventListener('click', () => {
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    });

    overlay.addEventListener('click', e => {
      if (e.target === overlay) {
        overlay.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    });

    overlay.querySelector('[data-m-popup-add-bundle]')?.addEventListener('click', () => {
      const mainBundleButton = document.querySelector('.m-ub-add-bundle-btn');
      if (mainBundleButton && !mainBundleButton.disabled) {
        mainBundleButton.click();
      }
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initBundleForms();
    initBundleImageToggle();
    initPopup();
  });

  // Variant change handler
  document.addEventListener('change', e => {
    if (!e.target.matches('.variant-option input[type="radio"]')) return;

    const section = document.querySelector('[data-m-upsell-section]');
    if (!section) return;

    const bundle = section.querySelector('.m-upsell-bundle');
    bundle?.classList.add('is-loading');

    fetch(`${window.location.pathname}?variant=${e.target.dataset.variantId}&sections=${section.dataset.sectionId}`)
      .then(res => res.json())
      .then(data => {
        const html = document.createElement('div');
        html.innerHTML = data[section.dataset.sectionId];

        const newBundle = html.querySelector('.m-upsell-bundle');
        const newPopup = html.querySelector('[data-m-popup-overlay]');

        if (newBundle) {
          if (bundle) {
            bundle.replaceWith(newBundle);
          } else {
            section.appendChild(newBundle);
          }
          initBundleForms(newBundle);
          initBundleImageToggle(newBundle);
        } else if (bundle) {
          bundle.remove();
        }

        const oldPopup = document.querySelector('[data-m-popup-overlay]');
        if (newPopup) {
          if (oldPopup) oldPopup.replaceWith(newPopup);
          else document.body.appendChild(newPopup);
          initPopup();
        } else if (oldPopup) {
          oldPopup.remove();
        }

        bundle?.classList.remove('is-loading');
      })
      .catch(err => {
        console.error('Upsell refresh failed', err);
        bundle?.classList.remove('is-loading');
      });
  });

})();

let upsellSwiper = null;

function initupsellSlider() {
  // Destroy old instance if exists
  if (upsellSwiper && typeof upsellSwiper.destroy === 'function') {
    upsellSwiper.destroy(true, true);
    upsellSwiper = null;
  }

  const sliderEl = document.querySelector('.m-cart-upsell-slider');
  if (!sliderEl) return;

  // Create new slider
  upsellSwiper = new Swiper(sliderEl, {
    slidesPerView: 1.4,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: { slidesPerView: 1.4 },
      480: { slidesPerView: 1.4 }
    }
  });

  initUpsellAjax()  
}
function initUpsellAjax() {
  const upsellButtons = document.querySelectorAll('.m-cart-upsell-btn');
  upsellButtons.forEach(function(button) {
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
  });
  const freshButtons = document.querySelectorAll('.m-cart-upsell-btn');
  freshButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (button.disabled) return;
      const variantId = button.getAttribute('data-variant-id');
      const originalText = button.innerHTML;
      button.disabled = true;
      button.innerHTML = '<span>Adding...</span>';
      import('@theme/events').then(({ CartUpdateEvent }) => {
        const cartDrawer = document.querySelector('cart-drawer-component');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        })
        .then(res => res.json())
        .then(() => fetch('/cart.js'))
        .then(res => res.json())
        .then(cart => {
          const event = new CartUpdateEvent(cart, 'manual-trigger', {
            itemCount: cart.item_count,
            source: 'cart-upsell',
            sections: {} 
          });
          document.dispatchEvent(event);
          if (cartDrawer?.hasAttribute('auto-open')) cartDrawer.open();
          button.innerHTML = '<span>Added!</span>';
          setTimeout(() => {
            button.disabled = false;
            button.innerHTML = originalText;
          }, 1500);
          if (typeof initupsellSlider === 'function') {
            setTimeout(() => {
              initupsellSlider();
            }, 1000);
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          button.disabled = false;
          button.innerHTML = originalText;
          alert('Unable to add item to cart. Please try again.');
        });
      });
    });
  });
}
